// src/components/training/summary/summaryFormat.ts
import { TimePercent } from "../../../types/SummaryDTO";

export const HR_ZONE_ORDER = ["G0", "G1", "G2", "G3", "G4", "0", "1", "2", "3", "4", "5", "6", "Z"];
export const HR_DOMAIN_ORDER = ["MODERATE", "HEAVY", "SEVERE", "EXTREME", "STRENGTH"];
export const STATS_ORDER = ["ORIENTEERING", "RUNNING", "ALTERNATIVE", "STRENGTH"] as const;

export const STAT_COLORS: Record<string, string> = {
  MODERATE: "#2e7d32",
  HEAVY: "#e77f1e",
  SEVERE: "#c62828",
  EXTREME: "#6a1b9a",
  STRENGTH: "#000000",
  MAP: "#0011ff",
  ORIENT: "#0011ff",
  RUN: "#333333",
  ALTER: "#555555",
};

export const parseIsoDateUtc = (isoDate: string): Date => new Date(`${isoDate}T00:00:00Z`);

export const formatDateLocal = (date: Date): string => {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
};

// H:MM z wiodącą spacją dla 1-cyfrowych godzin: " 5:02"
export const formatHMM = (seconds?: number): string => {
  const s = typeof seconds === "number" && !isNaN(seconds) ? seconds : 0;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);

  const hStr = h.toString().padStart(2, " "); // spacja zamiast zera
  const mStr = m.toString().padStart(2, "0");
  return `${hStr}:${mStr}`;
};

export const formatTimePercentCompact = (tp?: TimePercent): string => {
  const seconds = tp?.timeSeconds ?? 0;
  const pct = tp?.percent ?? 0;
  return `${formatHMM(seconds)} (${pct.toFixed(1)}%)`;
};

export const normalizeIsoDate = (value: unknown): string => {
  if (typeof value === "string") return value;

  // Jackson LocalDate czasem jako [yyyy, mm, dd]
  if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d] = value as [number, number, number];
    const mm = String(m).padStart(2, "0");
    const dd = String(d).padStart(2, "0");
    return `${y}-${mm}-${dd}`;
  }

  return "1970-01-01";
};

export const weekRangeFromWeekStart = (weekStartIso: string): { start: Date; end: Date } => {
  const start = parseIsoDateUtc(weekStartIso);
  const end = new Date(start);
  end.setUTCDate(start.getUTCDate() + 6);
  return { start, end };
};

export const formatDDMM = (d: Date): string => {
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}`;
};

export const splitWeekKey = (weekKey?: string) => {
  if (!weekKey) return { year: "", week: "" };
  const [year, week] = weekKey.split("-");
  return { year: year ?? "", week: week ?? "" };
};

export const sortKeysWithOrder = (keys: string[], order: string[]) => {
  return [...keys].sort((a, b) => {
    const ai = order.indexOf(a);
    const bi = order.indexOf(b);

    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;

    return a.localeCompare(b);
  });
};